import type { ShopIdToIsCabinOnly } from '../filterSlotsByResourceTypes'
import { getIsCabinOnlyConfiguration } from '../getIsCabinOnlyConfiguration'
import type { Shop } from '../../types'

/**
 * Builds a map of shop id → whether that shop uses CABIN_ONLY for the given journey's delivery model.
 * Used when resources span multiple shops (e.g. schedule/reservation from PRS) to pass into
 * filterSlotsByResourceTypes so CABIN_ONLY shops skip fitter–cabin pairing and expose cabin-only slots.
 * Shops not present in the map (or with false) are treated as FITTER_AND_CABIN.
 */
const buildShopIdToIsCabinOnly = (shops: Shop[], journey: string | undefined): ShopIdToIsCabinOnly => {
  const result: ShopIdToIsCabinOnly = {}
  for (const shop of shops) {
    if (getIsCabinOnlyConfiguration(shop, journey)) {
      result[shop.id] = true
    }
  }
  return result
}

export { buildShopIdToIsCabinOnly }
